export var EventType;
(function (EventType) {
    EventType[EventType["INCOMING"] = 0] = "INCOMING";
    EventType[EventType["OUTGOING"] = 1] = "OUTGOING";
    EventType[EventType["APPROVED"] = 2] = "APPROVED";
    EventType[EventType["LOCAL"] = 3] = "LOCAL";
})(EventType || (EventType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/components/EventLog/types.ts
// module id = 297
// module chunks = 0